/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hero_Cta_StudioInputs */

const en_directory_hero_cta_studio = /** @type {(inputs: Directory_Hero_Cta_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try AI Studio`)
};

const zh_directory_hero_cta_studio = /** @type {(inputs: Directory_Hero_Cta_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模型试玩`)
};

/**
* | output |
* | --- |
* | "Try AI Studio" |
*
* @param {Directory_Hero_Cta_StudioInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hero_cta_studio = /** @type {((inputs?: Directory_Hero_Cta_StudioInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hero_Cta_StudioInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hero_cta_studio(inputs)
	return zh_directory_hero_cta_studio(inputs)
});
export { directory_hero_cta_studio as "directory.hero.cta_studio" }